
<main class="row-documents-page">
	<header class="row-documents-header">
		<div>
			<h1>Supporting Documents</h1>
			<p>Report row supporting-document viewer</p>
		</div>
	</header>

	<div
		*ngIf="!hasValidContext"
		class="row-documents-message"
		role="alert"
	>
		Invalid supporting-document viewer link.
	</div>

	<div *ngIf="hasValidContext" class="row-documents-layout">
		<aside class="row-documents-sidebar">
			<div class="row-documents-section-heading">
				<h2>
					Documents
					<span *ngIf="!isLoading">
                  ({{ supportingFiles.length }})
               </span>
				</h2>

				<button
					type="button"
					class="row-documents-refresh"
					[disabled]="isLoading || isUploading"
					(click)="loadSupportingFiles()"
					title="Refresh documents"
					aria-label="Refresh documents"
				>
					<i class="pi pi-refresh" aria-hidden="true"></i>
				</button>
			</div>

			<section class="row-documents-upload">
				<h3>Upload documents</h3>

				<p class="row-documents-upload-description">
					Add evidence or approval documentation for this report row.
				</p>

				<p-fileUpload
					#fileUpload
					data-cy="pms-row-viewer-upload"
					mode="basic"
					name="supportingFile"
					chooseLabel="Choose files"
					[customUpload]="true"
					[multiple]="true"
					[disabled]="!canUpload"
					accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.csv"
					(uploadHandler)="onUpload($event)"
				></p-fileUpload>

				<p
					*ngIf="isUploading"
					class="row-documents-uploading"
					role="status"
				>
					<i
						class="pi pi-spin pi-spinner"
						aria-hidden="true"
					></i>
					Uploading documents...
				</p>

				<p
					*ngIf="uploadSuccess"
					class="row-documents-success"
					role="status"
				>
					<i
						class="pi pi-check-circle"
						aria-hidden="true"
					></i>
					{{ uploadSuccess }}
				</p>

				<p
					*ngIf="uploadError"
					class="row-documents-error"
					role="alert"
				>
					<i
						class="pi pi-exclamation-circle"
						aria-hidden="true"
					></i>
					{{ uploadError }}
				</p>
			</section>

			<div
				*ngIf="downloadError"
				class="row-documents-message row-documents-download-error"
				role="alert"
			>
				{{ downloadError }}
			</div>

			<div
				*ngIf="isLoading"
				class="row-documents-loading"
				role="status"
			>
				<i
					class="pi pi-spin pi-spinner"
					aria-hidden="true"
				></i>
				Loading supporting documents...
			</div>

			<div
				*ngIf="loadError"
				class="row-documents-message"
				role="alert"
			>
				<p>{{ loadError }}</p>

				<button
					type="button"
					class="row-documents-retry"
					(click)="loadSupportingFiles()"
				>
					Try again
				</button>
			</div>

			<p
				*ngIf="!isLoading && !loadError && supportingFiles.length === 0"
				class="row-documents-placeholder"
			>
				No supporting documents have been uploaded for this report row.
			</p>

			<ul
				*ngIf="supportingFiles.length > 0 && !loadError"
				class="row-documents-file-list"
			>
				<li
					*ngFor="
                  let file of supportingFiles;
                  trackBy: trackFileById
               "
					class="row-documents-file-entry"
				>
					<button
						type="button"
						class="row-documents-file-button"
						[class.is-selected]="selectedFile === file"
						[attr.aria-pressed]="selectedFile === file"
						(click)="selectFile(file)"
					>
						<i
							[class]="getFileIconClass(file)"
							aria-hidden="true"
						></i>

						<span class="row-documents-file-info">
                     <strong>
                        {{ file.fileName || 'Supporting document' }}
                     </strong>

                     <small *ngIf="file.createdBy">
                        Uploaded by {{ file.createdBy }}
                     </small>

                     <small *ngIf="file.createdDate">
                        {{
												 file.createdDate
													 | DatePropertyTimezone: true : true
											 }}
                     </small>
                  </span>
					</button>

					<button
						pButton
						type="button"
						icon="pi pi-download"
						class="p-button-text p-button-sm row-documents-download"
						[loading]="isDownloading(file)"
						[disabled]="!file.id || isDownloading(file)"
						[attr.aria-label]="
                     'Download ' + (file.fileName || 'document')
                  "
						title="Download document"
						data-cy="pms-row-viewer-download"
						(click)="downloadFile(file)"
					></button>
				</li>
			</ul>
		</aside>

		<section
			class="row-documents-preview"
			aria-label="Document preview"
		>
			<div
				*ngIf="!selectedFile"
				class="row-documents-preview-empty"
			>
				<i
					class="pi pi-file"
					aria-hidden="true"
				></i>

				<h2>Document Preview</h2>

				<p *ngIf="isLoading">
					Loading documents...
				</p>

				<p *ngIf="!isLoading && !loadError">
					Select a supporting document to view it here.
				</p>

				<p *ngIf="loadError">
					Documents could not be loaded.
				</p>
			</div>

			<app-pms-row-document-preview
				*ngIf="selectedFile"
				[taskInstanceId]="taskInstanceId"
				[pmsDataId]="pmsDataId"
				[targetRowId]="targetRowId"
				[file]="selectedFile"
			></app-pms-row-document-preview>
		</section>
	</div>
</main>
